import { render, staticRenderFns } from "./SectionPurposeAndValues.vue?vue&type=template&id=4ebeb75a&"
import script from "./SectionPurposeAndValues.vue?vue&type=script&lang=js&"
export * from "./SectionPurposeAndValues.vue?vue&type=script&lang=js&"
import style0 from "./SectionPurposeAndValues.vue?vue&type=style&index=0&id=4ebeb75a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default,MoleculesCommonMoleculeIconListWithTexts: require('/app/components/molecules/common/MoleculeIconListWithTexts.vue').default})
